<template>
  <div class="specialist-caption wrapper">
    <div class="specialist-caption__desc">
      <span class="item">Опубликовано: {{ created }}</span>
      <span class="item">Проверено: {{ verified }}</span>
      <span class="item">Обновлено: {{ updated }}</span>
    </div>
    <div class="specialist-caption__wrapper">
      <CSpecialistCardSmall v-bind="doctor" subtitle="Автор" />

      <CButtonTrigger
        v-if="button_text && button_trigger"
        :button-title="button_text"
        :button-trigger="button_trigger"
        :block-id="id"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import './styles.scss';
import CSpecialistCardSmall from '~/components/blocks/specialistCardSmall/CSpecialistCardSmall.vue';
import type { BlockAuthor } from '~/types/pages';
import CButtonTrigger from '~/components/buttonTrigger/CButtonTrigger.vue';

type Props = BlockAuthor;

defineProps<Props>();
</script>
